import { render } from "./ModernNotificationView.vue?vue&type=template&id=38cd44e4&scoped=true"
import script from "./ModernNotificationView.vue?vue&type=script&lang=js"
export * from "./ModernNotificationView.vue?vue&type=script&lang=js"

import "./ModernNotificationView.vue?vue&type=style&index=0&id=38cd44e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cd44e4"]])

export default __exports__